
      import Move from './move.vue'
      import type { App, Plugin } from 'vue'

      export const MovePlugin: Plugin = {
        install(app: App) {
          app.component('Move', Move)
        },
      }
      export { Move }
      